module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/learn.json
// module id = 759
// module chunks = 53460659540252